export const routes = {
  home: '/',
  user: '/user',
  slips: '/slips',
  pits: '/pits',
  contact_form: '/contact_form',
  login: '/login',
  first_login: '/first_login',
  admin: '/admin',
  admin_login: '/admin_login',
  unauthorized: '/unauthorized',
  password_change: '/password_change',
  admin_logs: '/admin_logs',
  admin_settings: '/admin_settings',
  rodo: '/information_clause',
};
